module.exports = __webpack_public_path__ + "static/himeji-castle-map-fd5cd63664515c814a806c0ece137f2b.jpg";